<template>
  <el-dialog
      fullscreen
      v-loading="loading"
      title="隐私政策"
      :visible.sync="visible"
      :before-close="handleClose">
        <div style="height: calc(90vh - 200px);">
          <file-reader v-if="currentFile"
                       ref="fileReader"
                       :file="currentFile"
                       :current-scale="currentScale"
                       :current-page.sync="currentPage"
                       @page-ready="handlePageReady">
          </file-reader>
        </div>

    <span slot="footer" class="dialog-footer flex-center-center">
      <el-button type="primary" :disabled="isShow" @click="handleConfirm">我已知晓</el-button>
    </span>
  </el-dialog>
</template>

<script>

import FileReader from "@/components/reader";
import privacy from "@/utils/privacy.pdf"

export default {
  name: "privacyDialog",
  components: {FileReader},
  watch: {
    currentPage: {
      handler(newVal) {
        if (newVal == this.pages) {
          this.isShow = false
        }
      }
    },
  },
  props:{
    visible: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      isShow: true,
      pages: '',
      loading: false,
      docLoading: false,
      currentFile:{
        id: 1234,
        type: 'pdf',
        src: privacy
      },
      docScale: 50,
      currentPage: 1,
    }
  },
  computed: {
    currentScale() {
      return this.docScale / 100;
    }
  },
  methods:{
    handleConfirm(){
      this.$emit('update:isAgree', true);
      this.handleClose()
    },
    handlePageReady(e) {
      this.pages = e.pagesCount || 0
      this.docLoading = false
    },
    handleClose() {
        this.updateDialog(false)
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    },
  }
}
</script>

<style scoped lang="less">
/deep/ .el-dialog__body{
  padding: 30px 0px;
}

/deep/ .is-disabled{
  background-color: #a0cfff !important;
  border-color: #a0cfff !important;
}

/deep/ .doc-page-tools {
  width: 48px;
  bottom: 48px;
  right: 20px ;
  position: absolute;

  .tools-btn {
    width: 32px;
    height: 32px;
    font-size: 20px;
    line-height: 32px;
    border-radius: 4px;
    display: block;
    color: #fff;
    text-decoration: none;
    background-color: rgba(146, 146, 146, 0.8);
    cursor: pointer;
    transition: all .25s ease-in-out;
    margin-top: 8px;
    user-select: none;
    text-align: center;
    border: 1px solid transparent;
  }

  .tools-btn:hover {
    background-color: rgb(146, 146, 146);
  }

  .tools-btn:active, .tools-btn:focus {
    border: 1px solid #cccccc;
  }

  .tools-btn:first-child {
    transform: rotate(-180deg);
  }
}
</style>
